import {Pipe, PipeTransform} from '@angular/core';
import {NgxFiltersService} from "../ngx-filters.service";
import {Filter} from "../ngx-types";

@Pipe({
  name: 'displayLabelFilter'
})
export class DisplayLabelFilterPipe implements PipeTransform {
  constructor(private filtersService: NgxFiltersService) {
  }

  transform(value: Filter, ...args: any[]): string {
    const hasConditionName = args[0];
    if (value) {
      return this.filtersService.getDisplayLabel(value, hasConditionName);
    }
    return null;
  }
}
